import { ProposedActionStatus } from '../chat/types';

// A failed approval changed nothing; replying "Approved" leads Siesta to tell the user the change
// is live. The outcome message it receives explains why it failed.
export const resumeMessageFor = (
  approve: boolean,
  status: ProposedActionStatus | undefined,
): string => {
  if (!approve) return 'Denied';
  return status === 'FAILED' ? 'Approved, but it could not be applied' : 'Approved';
};
